import { useDispatch, useSelector } from "react-redux";
import { defaultFormData } from "../config/mgmtDataConfig";
import { createManagementCompany } from "../services/managementAddService";
import { fetchManagementCompanies } from "../../../../../redux/mgmtCo/managementSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/mgmtCo/paginationSlice";

const useAddManagement = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const handleSubmit = async () => {
    try {
      const newCompany = await createManagementCompany(defaultFormData);
      dispatch(
        fetchManagementCompanies({ currentPage, rowsPerPage, searchQuery: "" })
      );
      return newCompany;
    } catch (error) {
      console.error("Error adding management company:", error);
      return null;
    }
  };

  return { handleSubmit };
};

export default useAddManagement;
